


















import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

import type { PageHeaderActionItem } from './types';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

// @TODO: Should these items have tooltips? Oh, these items should actually be ButtonIcon component that we haven't developed yet.

export default defineComponent({
    name: 'SdsPageHeaderActions',
    props: {
        item: {
            type: Object as PropType<PageHeaderActionItem>,
            required: true,
        },
    },
    setup(props) {
        const handleClick = () => {
            if (typeof props.item?.onClick === 'function') {
                props.item.onClick();
            }
        };

        return {
            handleClick,
        };
    },
    components: {
        SdsIcon,
    },
});
